module.exports = require('./helpers/bundle-url').getBundleURL('2YLlC') + "logo-dark.ba5147f0.svg";